import { jsx } from "react/jsx-runtime";
import { ButtonBase, alpha, styled, svgIconClasses } from "@mui/material";
import { forwardRef } from "react";
import { colorPickerName } from "../../../classes.js";
const doNotForward = /* @__PURE__ */ new Set(["bgcolor", "selected", "ownerState", "contrastColor", "size"]);
const borderWidth = 2;
const outlineWidth = borderWidth;
const borderRadius = 4;
const ChipBase = forwardRef((props, ref) => /* @__PURE__ */ jsx(ButtonBase, { ref, disableRipple: true, ...props }));
const Chip = styled(ChipBase, {
  name: colorPickerName,
  slot: "Swatch",
  overridesResolver: (_props, styles) => [styles.swatch],
  shouldForwardProp: (prop) => !doNotForward.has(prop)
})(({ theme, contrastColor = "#fff", selected = false, bgcolor = "#000", size }) => {
  const darkColor = theme.palette.tidalColors.slateBlueGray.A700;
  const mainColor = theme.palette.primary.main;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: size,
    height: size,
    flexShrink: 0,
    position: "relative",
    borderColor: theme.vars.palette.background.paper,
    borderRadius,
    borderWidth,
    borderStyle: "solid",
    boxShadow: `0px 0px 3px 0px ${alpha(darkColor, 0.56)} inset`,
    color: contrastColor,
    backgroundColor: bgcolor,
    outlineStyle: "solid",
    outlineWidth,
    outlineColor: `${alpha(mainColor, selected ? 1 : 0)}`,
    transition: "outline 0.3s ease",
    "&:hover": {
      // figma is 0.04
      outlineColor: selected ? mainColor : `${alpha(darkColor, 0.14)}`
    },
    "&:focus-visible": {
      // figma is 0.12
      outlineColor: selected ? mainColor : `${alpha(darkColor, 0.28)}`
    },
    [`& .${svgIconClasses.root}`]: {
      fontSize: Math.ceil(size * 0.6),
      opacity: selected ? 1 : 0,
      scale: selected ? 1 : 0,
      transition: "opacity 0.18s ease, scale 0.25s ease"
    }
  };
});
export {
  Chip,
  borderWidth,
  outlineWidth
};
//# sourceMappingURL=Chip.js.map
